import { ActionIcon, Anchor, Table, Badge, Text, Card, Group, Stack } from '@mantine/core'

// 人材一覧(/admin/users)のテーブル。行データは Rails 側で組み立てて props で受け取り、ここでは描画のみ。
// #1234 sm 未満はテーブルではなくカードのスタック表示にする(横スクロール前提の表をモバイルに出さない)。

function DetailLink({ row }) {
  if (!row.href) return null

  return (
    <ActionIcon
      component="a"
      href={row.href}
      variant="subtle"
      color="gray"
      aria-label={`${row.name}の詳細を表示`}
      title="詳細"
    >
      <span className="material-icons" aria-hidden="true">open_in_new</span>
    </ActionIcon>
  )
}

function AdminUserRowCard({ row }) {
  const nameNode = row.href
    ? <Anchor href={row.href} fw={600}>{row.name}</Anchor>
    : <Text fw={600} span>{row.name}</Text>

  return (
    <Card withBorder radius="md" padding="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap" mb={4}>
        <div>
          {row.kana && <Text size="xs" c="dimmed">{row.kana}</Text>}
          {nameNode}
        </div>
        <DetailLink row={row} />
      </Group>

      {typeof row.matchScore === 'number' && <Badge mb="xs" color="brand">マッチ度 {row.matchScore}%</Badge>}

      <Text fw={700} mb="xs">{row.priceLabel || '応相談'}</Text>

      {row.skills?.length > 0 && (
        <Text size="sm" c="dimmed" lineClamp={1} mb="xs">スキル: {row.skills.join('、')}</Text>
      )}

      <Group justify="space-between" gap="xs">
        <Text size="xs" c="dimmed">最終ログイン {row.lastSignInAtLabel}</Text>
        <Text size="xs" c="dimmed">登録 {row.registeredAtLabel}</Text>
      </Group>
    </Card>
  )
}

export default function AdminUserTable({ rows = [], emptyMessage = '該当する人材が見つかりませんでした。' }) {
  if (rows.length === 0) {
    return <Text c="dimmed" py="xl" ta="center">{emptyMessage}</Text>
  }

  return (
    <>
      <Table.ScrollContainer minWidth={760} visibleFrom="sm">
        <Table
          striped
          highlightOnHover
          withTableBorder
          verticalSpacing="sm"
          styles={{ td: { verticalAlign: 'middle' } }}
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>氏名</Table.Th>
              <Table.Th w={150}>希望単価</Table.Th>
              <Table.Th>スキル</Table.Th>
              <Table.Th w={150}>最終ログイン</Table.Th>
              <Table.Th w={110}>登録日</Table.Th>
              <Table.Th w={70}>詳細</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.id}>
                <Table.Td data-column="name">
                  {row.kana && <Text size="xs" c="dimmed">{row.kana}</Text>}
                  {row.href ? <Anchor href={row.href} fz="sm">{row.name}</Anchor> : row.name}
                  {typeof row.matchScore === 'number' && (
                    <Badge mt={4} size="sm" color="brand">マッチ度 {row.matchScore}%</Badge>
                  )}
                </Table.Td>
                <Table.Td>{row.priceLabel || '応相談'}</Table.Td>
                <Table.Td>
                  <Text fz="sm" lineClamp={1}>{row.skills?.length > 0 ? row.skills.join('、') : '—'}</Text>
                </Table.Td>
                <Table.Td><Text fz="sm" c="dimmed">{row.lastSignInAtLabel}</Text></Table.Td>
                <Table.Td><Text fz="sm" c="dimmed">{row.registeredAtLabel}</Text></Table.Td>
                <Table.Td><DetailLink row={row} /></Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>

      <Stack gap="sm" hiddenFrom="sm">
        {rows.map((row) => (
          <AdminUserRowCard key={row.id} row={row} />
        ))}
      </Stack>
    </>
  )
}
